import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

// import reactElementToJSXString from 'react-element-to-jsx-string';

import * as commonVar from 'libs/commonVar';

import {
  Container,
  Grid,
  Header,
  Icon,
  Image,
  Input,
  Segment,
  List,
  Divider,
  Breadcrumb,
  Menu
} from 'semantic-ui-react';
import { Footer, Button } from 'components';

import classNames from 'classnames/bind';
import styles from './Faq.css';
const cx = classNames.bind(styles);

class Faq extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { inner, detail, isDetailOpen } = this.props;
    // function
    const { onMovePage, onDetailAnswer } = this.props;
    //  검색
    const { searchText, onKeyPressSearch, onSearch } = this.props;

    // 응대 리스트
    const faqList = [
      {
        id: 'all',
        name: 'all',
        text: defineMessages(formatMessage({ id: 'Faq_1', defaultMessage: '전체' })),
        icon: 'ordered list'
      },
      {
        id: 'list-2',
        name: 'user',
        text: defineMessages(formatMessage({ id: 'Faq_2', defaultMessage: '가입' })),
        icon: 'user circle outline'
      },
      {
        id: 'list-3',
        name: 'license',
        text: defineMessages(formatMessage({ id: 'Faq_3', defaultMessage: '비용' })),
        icon: 'drivers license outline'
      },
      {
        id: 'list-4',
        name: 'startExam',
        text: defineMessages(formatMessage({ id: 'Faq_4', defaultMessage: '훈련 대상' })),
        icon: 'hourglass start'
      },
      {
        id: 'list-5',
        name: 'template',
        text: defineMessages(formatMessage({ id: 'Faq_5', defaultMessage: '훈련 양식' })),
        icon: 'options'
      },
      {
        id: 'list-6',
        name: 'exam',
        text: defineMessages(formatMessage({ id: 'Faq_6', defaultMessage: '훈련 실시' })),
        icon: 'tasks'
      },
      {
        id: 'list-7',
        name: 'target',
        text: defineMessages(formatMessage({ id: 'Faq_7', defaultMessage: '훈련 결과' })),
        icon: 'users'
      },
      {
        id: 'list-8',
        name: 'etc',
        text: defineMessages(formatMessage({ id: 'Faq_8', defaultMessage: '기타' })),
        icon: 'talk outline'
      }
    ];

    const faqDetailList = [
      // 가입
      {
        id: 'list-2',
        seq: 0,
        summary: defineMessages(formatMessage({ id: 'Faq_9', defaultMessage: 'MudFix란 무엇인가요?' })),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_10_1',
              defaultMessage: 'MudFix는 정보 보안 인식을 높이기 위한 <b>악성메일 대응 모의 훈련서비스</b> 입니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_10_2',
              defaultMessage: '기업의 경우 큰 돈을 들여 망분리를 했기 때문에 외부가 위협에 노출됐다 하더라도<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_10_3',
              defaultMessage: '내부망은 100% 안전하다고 믿고 있습니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_10_4',
              defaultMessage: '내부망으로 악성코드 유입은 있을 수 없을거라고 착각을 합니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_10_5',
              defaultMessage: '내부망과 외부망은 분명 분리되어 있겠지만 이를 연결시켜주는 것은 사람입니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_10_6',
              defaultMessage: '많은 기업이 이러한 문제를 안고 있는데,<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_10_7',
              defaultMessage: 'MudFix는 이러한 사람들에 대한 <b>훈련을 돕기 위한 서비스</b>입니다.'
            })
          ) +
          '</div>',
        isOften: true
      },
      {
        id: 'list-2',
        seq: 1,
        summary: defineMessages(formatMessage({ id: 'Faq_11', defaultMessage: 'MudFix이름의 유래는 어디서 왔나요?' })),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_12_1',
              defaultMessage: '기업이라는 거대한 공동체 안에서 <b>보안</b>은 모두에게 중요합니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_12_2',
              defaultMessage: '하지만 단 한명이라도 기업이라는 공동체의 문을 열어주게 되면<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_12_3',
              defaultMessage: '모든 사람들의 노력이 무너지고 맙니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_12_4',
              defaultMessage:
                '그러한 사람들뿐만 아니라 모두가 경각심을 갖고 자신의 정보를 지킬 수 있도록 훈련이 필요합니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_12_5',
              defaultMessage: "보통 <b>'미꾸라지 한마리가 온 물을 흐린다'</b> 라고 하죠<br />"
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_12_6',
              defaultMessage: '그래서 그러한 행동을 고치고 정보를 보호하기 위한다는 의미로<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_12_7',
              defaultMessage: '<b>미꾸라지(Mudfish) + 고치다(fix)의 의미를 갖고 MudFix</b>라고 지어졌습니다.'
            })
          ) +
          '</div>'
      },
      {
        id: 'list-2',
        seq: 2,
        summary: defineMessages(formatMessage({ id: 'Faq_13', defaultMessage: 'MudFix 서비스가 왜 필요한가요?' })),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_14_1',
              defaultMessage: '기업이라는 거대한 공동체 안에서 <b>보안</b>은 모두에게 중요합니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_14_2',
              defaultMessage: '하지만 단 한명이라도 기업이라는 공동체의 문을 열어주게 되면<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_14_3',
              defaultMessage: '모든 사람들의 노력이 무너지고 맙니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_14_4',
              defaultMessage: '그렇기 때문에 MudFix를 이용하여 보안을 위한 경각심을 갖도록<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_14_5',
              defaultMessage: '지속적으로 훈련을 실시해야 합니다.'
            })
          ) +
          '</div>'
      },
      {
        id: 'list-2',
        seq: 3,
        summary: defineMessages(formatMessage({ id: 'Faq_15', defaultMessage: '비회원도 훈련이 가능한가요?' })),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_16_1',
              defaultMessage: '비회원은 훈련이 불가능합니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_16_2',
              defaultMessage: 'MudFix는 서비스 가입시 5명까지 무료로 이용해 보실 수 있습니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_16_3',
              defaultMessage: '서비스 가입 후 이용해 보세요.'
            })
          ) +
          '</div>'
      },
      {
        id: 'list-2',
        seq: 4,
        summary: defineMessages(
          formatMessage({ id: 'Faq_17', defaultMessage: '서비스 가입시 필요한 정보는 무엇이 있나요?' })
        ),
        answerContent: defineMessages(
          formatMessage({
            id: 'Faq_18',
            defaultMessage: '사용하실 이메일, 비밀번호, 이름, 서비스명으로 간단하게 가입이 가능합니다.'
          })
        )
      },
      {
        id: 'list-2',
        seq: 5,
        summary: defineMessages(formatMessage({ id: 'Faq_19', defaultMessage: '아이디/비밀번호를 분실했습니다.' })),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_20_1',
              defaultMessage: '로그인 화면 하단에 비밀번호 찾기를 통하여<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_20_2',
              defaultMessage: '새로운 비밀번호로 재설정 할 수 있습니다.'
            })
          ) +
          '</div>'
      },
      {
        id: 'list-2',
        seq: 6,
        summary: defineMessages(
          formatMessage({ id: 'Faq_21', defaultMessage: '자사 자체적으로 사용하기위한 도입이 가능한가요?' })
        ),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_22_1',
              defaultMessage: '당연히 가능합니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_22_2',
              defaultMessage: '자세한 사항은 저희 회사로 문의해 주세요'
            })
          ) +
          "<div class='mt-10'>" +
          '<Icon name="mail" />' +
          (commonVar.isJapan === 1
            ? '<a href="mailto:support-m@jsecurity.co.jp">support-m@jsecurity.co.jp へメールを送る</a>'
            : defineMessages(
                formatMessage({
                  id: 'Faq_22_3',
                  defaultMessage:
                    '<a href="mailto:mudfix@jiran.com">mudfix@jiran.com로 메일 보내기</a>'
                })
              )) +
          '</div>' +
          '</div>'
      },
      // 비용
      // {
      //   id: 'list-3',
      //   seq: 0,
      //   summary: defineMessages(formatMessage({ id: 'Faq_23', defaultMessage: '결제수단은 어떤게 있나요?' })),
      //   answerContent:
      //     '<div>' +
      //     defineMessages(
      //       formatMessage({
      //         id: 'Faq_24_1',
      //         defaultMessage: '현재 무통장 입금으로 결제수단만 지원합니다.<br />'
      //       })
      //     ) +
      //     defineMessages(
      //       formatMessage({
      //         id: 'Faq_24_2',
      //         defaultMessage: '무통장입금의 경우 가상계좌로 입금이 가능합니다.<br />'
      //       })
      //     ) +
      //     defineMessages(
      //       formatMessage({
      //         id: 'Faq_24_3',
      //         defaultMessage: '해당계좌로 입금 시 실시간으로 입금확인이 가능하며, <br />'
      //       })
      //     ) +
      //     defineMessages(
      //       formatMessage({
      //         id: 'Faq_24_4',
      //         defaultMessage: '입금확인 후 자동으로 고객님께 입금 확인 메시지(SMS)를 발송해드리고 있습니다.'
      //       })
      //     ) +
      //     '</div>',
      //   isOften: true
      // },
      {
        id: 'list-3',
        seq: 1,
        summary: defineMessages(formatMessage({ id: 'Faq_25', defaultMessage: '라이센스 기간은 어떻게 되나요?' })),
        answerContent: defineMessages(
          formatMessage({
            id: 'Faq_26',
            defaultMessage: '<div>모든 라이센스의 기간은 1년으로 동일합니다.</div>'
          })
        )
      },
      {
        id: 'list-3',
        seq: 2,
        summary: defineMessages(
          formatMessage({ id: 'Faq_27', defaultMessage: '라이센스와 구축형의 차이는 무엇인가요?' })
        ),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_28_1',
              defaultMessage: "<div className={cx('bold')}>라이센스</div>"
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_28_2',
              defaultMessage: '<div>- 별도의 서버장비 없이 저희측에서 제공하는 서버를 이용합니다.</div>'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_28_3',
              defaultMessage: "<div className={cx('bold')}>구축형</div>"
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_28_4',
              defaultMessage: '<div>- 고객사에 서버 장비를 포함하여 MudFix를 고객사에 맞춰 서비스를 이용합니다.</div>'
            })
          ) +
          '</div>'
      },
      {
        id: 'list-3',
        seq: 3,
        summary: defineMessages(
          formatMessage({ id: 'Faq_29', defaultMessage: '구축형 라이센스 구입방식은 어떻게 이루어 지나요?' })
        ),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_30_1',
              defaultMessage: '구축형 라이센스의 구입은 저희에게 직접 문의해 주세요'
            })
          ) +
          "<div class='mt-10'>" +
          '<Icon name="mail" />' +
          (commonVar.isJapan === 1
            ? '<a href="mailto:support-m@jsecurity.co.jp">support-m@jsecurity.co.jp へメールを送る</a>'
            : defineMessages(
                formatMessage({
                  id: 'Faq_30_2',
                  defaultMessage:
                    '<a href="mailto:mudfix@jiran.com">mudfix@jiran.com로 메일 보내기</a>'
                })
              )) +
          '</div>' +
          '</div>'
      },
      // {
      //   id: 'list-3',
      //   seq: 4,
      //   summary: defineMessages(
      //     formatMessage({ id: 'Faq_31', defaultMessage: '구축형 라이센스 구매시 견적서는 어떻게 받을 수 있나요?' })
      //   ),
      //   answerContent: defineMessages(
      //     formatMessage({
      //       id: 'Faq_32',
      //       defaultMessage: '<div>구축형 라이센스를 구매하는 과정에서 필요하신 서류나 요청사항을 해결해 드립니다.</div>'
      //     })
      //   )
      // },
      {
        id: 'list-3',
        seq: 5,
        summary: defineMessages(formatMessage({ id: 'Faq_33', defaultMessage: '환불 정책은 어떻게 되나요?' })),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_34_1',
              defaultMessage: '사용하신 라이센스에 대해서는 환불이 불가합니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_34_2',
              defaultMessage: '또한 구입하신지 2주가 지난 라이센스도 환불이 불가합니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_34_3',
              defaultMessage: '저희 고객센터로 문의해주세요'
            })
          ) +
          "<div class='mt-10'>" +
          '<Icon name="mail" />' +
          (commonVar.isJapan === 1
            ? '<a href="mailto:support-m@jsecurity.co.jp">support-m@jsecurity.co.jp へメールを送る</a>'
            : defineMessages(
                formatMessage({
                  id: 'Faq_34_4',
                  defaultMessage:
                    '<a href="mailto:mudfix@jiran.com">mudfix@jiran.com로 메일 보내기</a>'
                })
              )) +
          '</div>' +
          '</div>'
      },
      // 훈련 대상
      {
        id: 'list-4',
        seq: 0,
        summary: defineMessages(formatMessage({ id: 'Faq_35', defaultMessage: '일괄등록이 가능한가요?' })),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_36_1',
              defaultMessage: "단일 대상을 <b>'대상자 추가'</b>를 통해서 등록이 가능하고 <br />"
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_36_2',
              defaultMessage: "다수의 대상을 추가할 때에는 <b>'엑셀 업로드'</b>에서 양식을 다운로드 하고<br />"
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_36_3',
              defaultMessage: '엑셀 양식을 작성하여 업로드를 통해서 일괄로 등록이 가능합니다.'
            })
          ) +
          '</div>'
      },
      {
        id: 'list-4',
        seq: 1,
        summary: defineMessages(formatMessage({ id: 'Faq_37', defaultMessage: '그룹별로 대상을 관리할 수 있나요?' })),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_38_1',
              defaultMessage: '저희는 태그라는 그룹핑을 통해서 관리 할 수 있습니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_38_2',
              defaultMessage: '해쉬태그와 같은 기능으로 어떤 형태든 사용자가 손쉽게 태그를 만들고,<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_38_3',
              defaultMessage: '대상자를 쉽게 그룹핑 하고 관리 할 수 있습니다.'
            })
          ) +
          '</div>'
      },
      // 훈련 양식
      {
        id: 'list-5',
        seq: 0,
        summary: defineMessages(
          formatMessage({ id: 'Faq_39', defaultMessage: '그룹별로 훈련 유형을 선택할 수 있나요?' })
        ),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_40_1',
              defaultMessage: '다양한 훈련 양식을 제공하고 마찬가지로 태그기능을 제공하고 있습니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_40_2',
              defaultMessage: '원하는 그룹 형태를 태그로 만들어서 훈련을 진행하시면 됩니다.'
            })
          ) +
          '</div>'
      },
      {
        id: 'list-5',
        seq: 1,
        summary: defineMessages(formatMessage({ id: 'Faq_41', defaultMessage: '훈련 양식을 수정할 수 있나요?' })),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_42_1',
              defaultMessage: '기본적으로 제공되는 훈련양식을 사용자가 원하는데로 수정 할 수 있도록<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_42_2',
              defaultMessage: '기본 템플릿을 복제하여 사용 할 수 있습니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_42_3',
              defaultMessage: '원하는 템플릿을 간단하게 복제해서 다양한 형태로 수정해서 훈련을 진행 할 수 있습니다.'
            })
          ) +
          '</div>'
      },
      // 훈련 실시
      {
        id: 'list-6',
        seq: 0,
        summary: defineMessages(
          formatMessage({ id: 'Faq_43', defaultMessage: '훈련 실행 전 발송이 가능한 상태인지 점검할 수 있나요?' })
        ),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_44_1',
              defaultMessage: '네 테스트 메일을 발송해서 각각의 대상자에게 메일이 정상적으로 발송되는지'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_44_2',
              defaultMessage: '미리 확인해 볼 수 있습니다.'
            })
          ) +
          '</div>'
      },
      // {
      //   id: 'list-6',
      //   seq: 1,
      //   summary: defineMessages(formatMessage({ id: 'Faq_', defaultMessage: })),
      //         '메일을 발송하기 전에 대상자들에게 test발송이 가능한가요?',
      //   answerContent: defineMessages(formatMessage({ id: 'Faq_', defaultMessage:
      //         (
      //     "<div>
      //       "<div>???</div>
      //     </div>
      //   )
      // },
      {
        id: 'list-6',
        seq: 2,
        summary: defineMessages(
          formatMessage({
            id: 'Faq_45',
            defaultMessage: '보안상 웹 상에서 이 서비스를 진행하기 어려운데, 다른 방법이 있을까요?'
          })
        ),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_46_1',
              defaultMessage: '외부에서 제공하는 메일서버를 이용 할 수도 있지만,<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_46_2',
              defaultMessage: '구축형으로 고객사에 직접 서버를 설치하고 고객사내에 메일서버를 이용해서 <br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_46_3',
              defaultMessage: '서비스를 진행 가능합니다.'
            })
          ) +
          '</div>'
      },
      // // 훈련 결과
      {
        id: 'list-7',
        seq: 1,
        summary: defineMessages(
          formatMessage({ id: 'Faq_49', defaultMessage: '감염 PC 및 파일을 따로 관리 가능한가요?' })
        ),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_50_1',
              defaultMessage: '훈련 실시 후 훈련 결과보기에서 각 대상자, 태그, 감염 PC, 감염 파일별로<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_50_2',
              defaultMessage: '사용자가 손쉽게 결과를 확인 할 수 있습니다.'
            })
          ) +
          '</div>'
      },
      {
        id: 'list-7',
        seq: 2,
        summary: defineMessages(
          formatMessage({
            id: 'Faq_51',
            defaultMessage: '감염자의 파일 목록을 볼 수 있는데 저의 파일을 실제로 복제하는 것인가요?'
          })
        ),
        answerContent: defineMessages(
          formatMessage({
            id: 'Faq_52',
            defaultMessage: '실제 파일을 복제하는 것이 아닌 해당 감염 PC의 파일 목록만 저장합니다.'
          })
        )
      },
      // 기타
      {
        id: 'list-8',
        seq: 0,
        summary: defineMessages(
          formatMessage({ id: 'Faq_53', defaultMessage: 'SMTP 설정이 필요한 이유는 무엇인가요?' })
        ),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_54_1',
              defaultMessage: '저희가 제공하는 메일서버보다 고객님의 메일 서버를 설정하는 것이 <br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_54_2',
              defaultMessage: '서비스를 이용하는데 있어서 더 효율적이고 원활한 사용이 가능합니다.'
            })
          ) +
          '</div>'
      },
      {
        id: 'list-8',
        seq: 2,
        summary: defineMessages(formatMessage({ id: 'Faq_57', defaultMessage: '1:1로 문의를 드리고 싶습니다.' })),
        answerContent:
          '<div>' +
          defineMessages(
            formatMessage({
              id: 'Faq_58_1',
              defaultMessage: '아래의 방법으로 저희에게 연락을 주시면 1:1로 도움을 드립니다.<br />'
            })
          ) +
          defineMessages(
            formatMessage({
              id: 'Faq_58_2',
              defaultMessage: '연락 가능한 시간: 월 ~ 금 오전 10:00 ~ 18:00'
            })
          ) +
          "<div class='mt-10'>" +
          '<Icon name="mail" />' +
          (commonVar.isJapan === 1
            ? '<a href="mailto:support-m@jsecurity.co.jp">support-m@jsecurity.co.jp へメールを送る</a>'
            : defineMessages(
                formatMessage({
                  id: 'Faq_58_3',
                  defaultMessage:
                    '<a href="mailto:mudfix@jiran.com">mudfix@jiran.com로 메일 보내기</a>'
                })
              )) +
          '</div>' +
          '</div>',
        isOften: true
      }
    ];

    let filteredDetailList = [];
    let currentFaq = '';
    const FavoriteMenu = [];
    const MenuInner = faqList.map((faqItem, index) => {
      // 현재 선택된 메뉴
      if (inner === faqItem.id) {
        currentFaq = faqItem.text;

        // 필터 처리
        filteredDetailList = faqDetailList.filter(faqDetail => {
          return faqItem.id === 'all' || faqDetail.id === faqItem.id;
        });
      }

      // updatedList = updatedList.filter(function(item){
      //   return item.toLowerCase().search(event.target.value.toLowerCase()) !== -1;
      // });

      FavoriteMenu.push(
        <div
          key={index}
          className={cx('each-function')}
          onClick={() => {
            onMovePage(faqItem.id);
          }}>
          <Icon name={faqItem.icon} size="huge" />
          <div className={cx('inner-text')}>{faqItem.text}</div>
        </div>
      );

      return (
        <Menu.Item
          key={index}
          name={faqItem.name}
          active={inner === faqItem.id}
          onClick={() => {
            onMovePage(faqItem.id);
          }}>
          {faqItem.text}
        </Menu.Item>
      );
    });

    // 검색 필터 처리
    if (!!searchText) {
      filteredDetailList = filteredDetailList.filter(faqDetail => {
        return (
          // 제목 검색 ' '를 빼면 특수문자 검색시 에러발생함
          faqDetail.summary.toLowerCase().search(searchText) !== -1 ||
          faqDetail.answerContent.toLowerCase().search(searchText) !== -1
          // faqDetail.summary.search(' ' + searchText) !== -1
          // 내용 검색
          // reactElementToJSXString(faqDetail.answerContent).search(searchText) !== -1
        );
      });
    }

    //
    const SearchArea = (
      <div className={cx('faq-search-area')}>
        <Input
          className={cx('input-search')}
          size="large"
          placeholder={defineMessages(formatMessage({ id: 'Faq_59', defaultMessage: '검색' }))}
          onKeyPress={e => {
            onKeyPressSearch(e, inner, detail);
          }}
        />
        <Button
          className={cx('bt-search')}
          fontColor="#757575"
          size="large"
          icon="search"
          onClick={e => {
            onSearch(e, inner, detail);
          }}
        />
      </div>
    );

    const AnswerDetail = (
      <div className={cx('answer-content')}>
        <Header as="h1" content={currentFaq} />
        <Divider className={cx('bold-divider')} />
        <div className={cx('answer-list-wrapper')}>
          {filteredDetailList.length > 0 ? (
            filteredDetailList.map((answerDetail, index) => (
              <div key={index} className={cx({ isOpen: isDetailOpen.indexOf(index) !== -1 })}>
                {index !== 0 && <Divider />}
                <div
                  className={cx('each-detail')}
                  onClick={() => {
                    onDetailAnswer(index);
                  }}>
                  <div className={cx('answer-seq')}>{index + 1}</div>
                  <div className={cx('inner-text')}>{answerDetail.summary}</div>
                  <Icon name={isDetailOpen.indexOf(index) !== -1 ? 'chevron up' : 'chevron down'} />
                </div>
                <div className={cx('answer-detail')}>{ReactHtmlParser(answerDetail.answerContent)}</div>
              </div>
            ))
          ) : (
            <div>{defineMessages(formatMessage({ id: 'Faq_60', defaultMessage: '검색 결과 없음' }))}</div>
          )}
        </div>
      </div>
    );

    return (
      <div className={cx('faq-wrapper')}>
        <div className={cx('faq-wrapper-inner')}>
          {!!inner ? (
            <div className={cx('faq-detail')}>
              {/* FAQ 상세 화면 */}
              <Segment vertical>
                <Container className={cx('area-title')} text>
                  <div>
                    <Header
                      as="h1"
                      content={'MudFix ' + defineMessages(formatMessage({ id: 'Faq_61', defaultMessage: '고객 센터' }))}
                    />
                  </div>
                  {SearchArea}
                </Container>
                <Divider />
                {/* 위치 표시 */}
                <Container text>
                  <Breadcrumb size="small">
                    <Breadcrumb.Section
                      link
                      onClick={() => {
                        onMovePage('');
                      }}>
                      {defineMessages(formatMessage({ id: 'Faq_61', defaultMessage: '고객 센터' }))}
                    </Breadcrumb.Section>
                    {!!inner && <Breadcrumb.Divider icon="right chevron" />}
                    {!!inner && (
                      <Breadcrumb.Section
                        link
                        onClick={() => {
                          onMovePage(inner);
                        }}>
                        {currentFaq}
                      </Breadcrumb.Section>
                    )}
                    {!!detail && <Breadcrumb.Divider icon="right chevron" />}
                    {!!detail && (
                      <Breadcrumb.Section
                        active
                        onClick={() => {
                          onMovePage(detail);
                        }}>
                        {detail}
                      </Breadcrumb.Section>
                    )}
                  </Breadcrumb>
                </Container>
                <Divider className={cx('mb-0')} />
                {/* 본문 */}
                <div className={cx('faq-detailContent')}>
                  <div className={cx('faq-detailContent-inner')}>
                    <Menu className={cx('faq-detailMenu')} pointing secondary vertical>
                      {MenuInner}
                    </Menu>
                    <div className={cx('faq-detailAnswer')}>{AnswerDetail}</div>
                  </div>
                </div>
              </Segment>
            </div>
          ) : (
            /* FAQ 메인 화면 */
            <div className={cx('faq-main')}>
              {/* ------------------------------ ------------------------------ */}
              <Segment textAlign="left" className={cx('area-1')} vertical>
                <Container text className={cx('main-title-area')}>
                  <div>
                    <Header
                      as="h3"
                      className={cx('area-1-text mb-7')}
                      content={defineMessages(formatMessage({ id: 'Faq_62', defaultMessage: '안녕하세요.' }))}
                    />
                    <Header as="h3" className={cx('area-1-text')}>
                    {/* <Image className={cx('logo')} src="/img/logo/m_logo.png" /> */}
                      {`MudFix `}
                      {defineMessages(formatMessage({ id: 'Faq_63', defaultMessage: '고객센터 입니다.' }))}
                    </Header>
                    <Header
                      as="h3"
                      className={cx('area-1-text')}
                      content={defineMessages(formatMessage({ id: 'Faq_64', defaultMessage: '무엇을 도와드릴까요?' }))}
                    />
                  </div>
                  {SearchArea}
                </Container>
              </Segment>
              {/* ------------------------------ 자주 찾는 기능 ------------------------------ */}
              <Segment textAlign="left" className={cx('area-2')} vertical>
                <Container text>
                  <Header
                    as="h2"
                    content={defineMessages(formatMessage({ id: 'Faq_68', defaultMessage: '자주 찾는 기능' }))}
                  />
                  <div className={cx('favorite-function')}>{FavoriteMenu}</div>
                </Container>
              </Segment>
              {/* ------------------------------ 자주 하는 질문 ------------------------------ */}
              <Segment textAlign="left" className={cx('area-3')} vertical>
                <Container text>
                  <Header
                    as="h2"
                    content={defineMessages(formatMessage({ id: 'Faq_69', defaultMessage: '자주 하는 질문' }))}
                  />
                  <div className={cx('favorite-question')}>
                    <List ordered>
                      {faqDetailList.map((answerDetail, index) => {
                        return (
                          !!answerDetail.isOften && (
                            <List.Item as="a" key={index}>
                              <div
                                className={cx('each-function')}
                                onClick={() => {
                                  onMovePage(answerDetail.id);
                                  onDetailAnswer(answerDetail.seq);
                                }}>
                                <div className={cx('inner-text')}>{answerDetail.summary}</div>
                              </div>
                            </List.Item>
                          )
                        );
                      })}
                    </List>
                  </div>
                </Container>
              </Segment>
              {/* ------------------------------ 이메일로 문의 하기 ------------------------------ */}
              <Segment textAlign="left" className={cx('area-4')} vertical>
                <Container text>
                  <Header
                    as="h2"
                    content={defineMessages(formatMessage({ id: 'Faq_70', defaultMessage: '문의하기' }))}
                  />
                  <div className={cx('email-question')}>
                    <div>
                      <Icon name="mail" />
                      {commonVar.isJapan === 1 ? (
                        <a href={'mailto:support-m@jsecurity.co.jp'}>{'support-m@jsecurity.co.jpへメールを送る'}</a>
                      ) : (
                        <a href={'mailto:mudfix@jiran.com'}>
                          {defineMessages(
                            formatMessage({
                              id: 'Faq_65',
                              defaultMessage: 'mudfix@jiran.com로 메일 보내기.'
                            })
                          )}
                        </a>
                      )}
                    </div>
                  </div>
                </Container>
              </Segment>
            </div>
          )}
          <Footer />
        </div>
      </div>
    );
  }
}

Faq.propTypes = {};
Faq.defaultProps = {};

export default injectIntl(Faq);



// WEBPACK FOOTER //
// ./src/script/components/intro/Faq.js